import React, { useState, useEffect, useRef } from 'react';
import logo from './images/default-monochrome.svg';
import { initializeApp } from "firebase/app";
import 'firebase/storage';
import { getStorage, ref, getDownloadURL, uploadBytes } from "firebase/storage";
import Hamburger from 'hamburger-react';
import { motion } from "framer-motion";
import { navbarAnimation } from "./utils";
import { btnVar } from "./utils";


const firebaseConfig = {
  apiKey: "AIzaSyBqoeR8NJrZW0wMtuoFAfyOXdt3ZXwPD4w",
  authDomain: "secondportofolio.firebaseapp.com",
  projectId: "secondportofolio",
  storageBucket: "secondportofolio.appspot.com",
  messagingSenderId: "216128939606",
  appId: "1:216128939606:web:e102d9a05903485e98bdf7"
};

const app = initializeApp(firebaseConfig);

function Header() {

  const [isOpen, setOpen] = useState(false)
  const menuRef = useRef(null)


  const handleMenu = (e) => {
    setOpen(false)
  }

  useEffect( () => {
    // {isOpen && (menuRef.current.style.color = 'red')}
    {!isOpen && (menuRef.current.style.color = '#16e0bd')}

  }, [])




  const downloadResume =  (e) => {
    const url = 'https://firebasestorage.googleapis.com/v0/b/secondportofolio.appspot.com/o/My-resume.docx?alt=media&token=8870c906-9021-4ad5-85ef-89b9bfd5a5c1'
    const storageRef = app.storage().ref()
    const fileRef = storageRef.child('My-resume.docx')
    const fetchApi = () => {

    }
    fileRef.getDownloadURL()
  .then((url) => {
    // `url` is the download URL for 'images/stars.jpg'

    // This can be downloaded directly:
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = (event) => {
      const blob = xhr.response;
    };
    xhr.open('GET', url);
    xhr.send();

    // Or inserted into an <img> element
    //<button onClick={async() => {await downloadResume()}}></button>
  })
  .catch((error) => {
    // Handle any errors
  });
    }

    const variants = {
      hidden: {
        y: -250
      },
      visible: {
        y: -10,
        transition: {
          delay: 0.5,
          type: 'spring',
          stiffness: 500,
        },
      },
    }


    return (
        <motion.div className='header'
        variants={navbarAnimation}
        initial='hidden'
        animate='show'
        transition={{ delay: 0.2, duration: 1.5, stiffness: 500, type: 'spring' }}
        >
            <div className='logo-div'
            // initial='hidden'
            // animate='visible'
            // variants={variants}

            >
                {/* <img className='logo' src={logo} alt='logo' /> */}
                <svg className='logo' width='100' height='100' viewBox='-100 -30 200 200'>
                  <defs>
                    <path 
                    id='branch'
                    d='
                    M 0 0 L 0 -90
                    M 0 -20 L 20 -34
                    M 0 -20 L -20 -34
                    M 0 -40 L 20 -54
                    M 0 -40 L -20 -54
                    M 0 -60 L 20 74
                    M 0 -60 L -20 -74
                    '
                    stroke='#16e0bd'
                    stroke-width='5'
                    />
                  </defs>
                  <use href='#branch' />
                  <use href='#branch' transform='rotate(60)' />
                  <use href='#branch' transform='rotate(120)' />
                  <use href='#branch' transform='rotate(180)' />
                  <use href='#branch' transform='rotate(240)' />
                  <use href='#branch' transform='rotate(300)' />
                </svg>
            </div>
            <nav className='desktop-nav'
              // initial='hidden'
              // animate='visible'
              // variants={variants}
            >
                <ul>
                    <li><a href='#about'>About</a></li>
                    <li><a href='#exp'>Experience</a></li>
                    <li><a href='#work'>Work</a></li>
                    <li><a href='#contact'>Contact</a></li>
                </ul>
                <a download='Tosin_Resume' href='https://firebasestorage.googleapis.com/v0/b/secondportofolio.appspot.com/o/My-resume.docx?alt=media&token=8870c906-9021-4ad5-85ef-89b9bfd5a5c1'>
                <motion.button
              // initial='hidden'
                whileHover='hover'
                variants={btnVar}

                >Resume</motion.button>
                </a>
                
            </nav>
            <div  className='mobile-nav'
            
            >
              <div ref={menuRef} className='hamburger'><Hamburger ref={menuRef} className='hamburger' toggled={isOpen} toggle={setOpen} /></div>
                {
                  isOpen && (
                  <ul>
                    <li><a  onClick={() => {handleMenu()}} href='#about'>About</a></li>
                    <li><a  onClick={() => {handleMenu()}} href='#exp'>Experience</a></li>
                    <li><a  onClick={() => {handleMenu()}} href='#work'>Work</a></li>
                    <li><a  onClick={() => {handleMenu()}} href='#contact'>Contact</a></li>
                    <li>
                    <a download='Tosin_Resume' href='https://firebasestorage.googleapis.com/v0/b/secondportofolio.appspot.com/o/My-resume.docx?alt=media&token=8870c906-9021-4ad5-85ef-89b9bfd5a5c1'>
                      <button onClick={() => {handleMenu()}}>Resume</button>
                    </a>
                    </li>
                  </ul>
                  )
                }
            </div>
        </motion.div>
    )
}

export default Header
